import React from 'react';
import { View, Text } from 'react-native';

const ErrorMessage = ({ message }) => (
	<View style={{ marginTop: 75 }}>
		<Text
			style={{
				color: 'red',
				fontSize: 24,
				fontWeight: 'bold',
				textAlign: 'center',
			}}
		>
			{message}
		</Text>
	</View>
);

export default ErrorMessage;
